<app-public-layout-wrapper>
  <div leftside class="container-side-left">
    <h2>
      {{ 'login.welcome.footer.title' | translate }}
    </h2>
    <button class="ind-btn-wrapper-100 ind-btn ind-btn--secondary" [routerLink]="registerPath">
      {{ 'buttons.labels.create.accounts' | translate }}
    </button>
  </div>
  <ng-container rightside>
    <app-header-public />

    <app-login-form
      *ngIf="isShownLoginForm"
      [loginError]="loginError$"
      (submitForm)="onSubmit($event)"
      (completeVerification)="onCompleteVerification($event)" />

    <app-verifying-email *ngIf="verifyingEmail.isShown" [email]="verifyingEmail.email" />
  </ng-container>
</app-public-layout-wrapper>
